class BlockProductMediaGallery extends HTMLElement {
    constructor() {
        super();
    }

    async connectedCallback() {
        const splideElement = this.querySelector(".splide");

        if (!splideElement) return;

        await ResourceCoordinator.requestVendor("Splide");

        const splide = new Splide(splideElement, {
            width: "100%",
            pagination: false,
            breakpoints: {
                768: {
                    pagination: true,
                },
            },
        });

        let thumbnails = this.getElementsByClassName("thumbnail");
        let current;
        const thumbnailList = this.querySelector(".no-scrollbar");

        for (let i = 0; i < thumbnails.length; i++) {
            initThumbnail(thumbnails[i], i);
        }

        function initThumbnail(thumbnail, index) {
            let dragged = false;

            thumbnail.addEventListener("click", function (event) {
                if (dragged) {
                    event.preventDefault();
                    return;
                }

                splide.go(index);
            });

            thumbnail.addEventListener("dragstart", () => {
                dragged = true;
            });

            thumbnail.addEventListener("pointerdown", () => {
                dragged = false;
            });

            thumbnail.addEventListener("pointermove", (event) => {
                if (event.pointerType === "mouse" && event.buttons === 1 && (Math.abs(event.movementX) > 3 || Math.abs(event.movementY) > 3)) {
                    dragged = true;
                }
            });
        }

        if (thumbnailList) {
            let isDragging = false;
            let pointerId = null;
            let startX = 0;
            let startScrollLeft = 0;

            thumbnailList.addEventListener("pointerdown", (event) => {
                if (event.pointerType !== "mouse") return;

                isDragging = false;
                pointerId = event.pointerId;
                startX = event.clientX;
                startScrollLeft = thumbnailList.scrollLeft;
            });

            thumbnailList.addEventListener("pointermove", (event) => {
                if (pointerId === null || event.pointerId !== pointerId) return;

                if (!isDragging) {
                    if (Math.abs(event.clientX - startX) <= 3) return;

                    isDragging = true;
                    thumbnailList.setPointerCapture(pointerId);
                }

                thumbnailList.scrollLeft = startScrollLeft - (event.clientX - startX);
            });

            const stopDragging = () => {
                isDragging = false;
                pointerId = null;
            };

            thumbnailList.addEventListener("pointerup", stopDragging);
            thumbnailList.addEventListener("pointercancel", stopDragging);
        }

        splide.on("mounted move", () => {
            const thumbnail = thumbnails[splide.index];

            if (thumbnail) {
                if (current) {
                    current.classList.remove("active-thumbnail");
                }

                thumbnail.classList.add("active-thumbnail");
                current = thumbnail;

                thumbnail.scrollIntoView({ block: "nearest", inline: "nearest" });
            }

            this.querySelectorAll("mattress-layer").forEach((layer) => layer.reset());
        });

        this.querySelector("block-product-media-gallery-placeholder").remove();

        splide.mount();
    }
}

customElements.define("block-product-media-gallery", BlockProductMediaGallery);

const MATTRESS_LAYER_SLIDE_HEIGHT_CLASSES = ["h-[212px]", "md:h-[435px]", "lg:h-[311px]", "screen-1440:h-[486px]", "screen-1920:h-[672px]"];

class MattressLayer extends HTMLElement {
    reset() {
        const panels = this.querySelectorAll(".info-panel");
        const activeHotspots = this.querySelectorAll(".hotspot-active");
        const idleHotspots = this.querySelectorAll(".hotspot-idle");

        panels.forEach((p) => p.classList.add("hidden"));
        activeHotspots.forEach((el) => el.classList.add("hidden"));
        idleHotspots.forEach((el) => el.classList.remove("hidden"));

        const slide = this.closest(".splide__slide");
        if (slide) {
            slide.classList.remove("h-auto");
            slide.classList.add(...MATTRESS_LAYER_SLIDE_HEIGHT_CLASSES);
        }
    }

    connectedCallback() {
        this.querySelectorAll(".hotspot").forEach((hotspot) => {
            hotspot.addEventListener("click", () => {
                const panel = this.querySelector(`[data-panel="${hotspot.dataset.controls}"]`);
                const isHidden = panel.classList.contains("hidden");

                if (isHidden) {
                    this.reset();

                    hotspot.querySelector(".hotspot-idle").classList.add("hidden");
                    hotspot.querySelector(".hotspot-active").classList.remove("hidden");
                    panel.classList.remove("hidden");

                    const slide = this.closest(".splide__slide");
                    if (slide) {
                        slide.classList.remove(...MATTRESS_LAYER_SLIDE_HEIGHT_CLASSES);
                        slide.classList.add("h-auto");
                    }
                }
            });
        });
    }
}

customElements.define("mattress-layer", MattressLayer);
